import * as yup from 'yup';
import { yupUtils, isValidYupSchema } from '../../utils/yup/utils';
import { ProjectErrorType, ProjectErrors } from '../../utils/errors/types';
import { getProjectErrorForCode, getProjectErrorFromRawError, isProjectError } from '../../utils/errors';
import { MentorShort } from '../types/mentorShort';

export const MinimalMentorShortSchema = yup.object().shape({
  authorId: yupUtils.stringRequired('Select the mentor'),
  title: yupUtils.stringRequired('The title is required'),
  durationSeconds: yupUtils.numberRequired,
  isActive: yupUtils.booleanRequired,
});

// `order` is not edited in the form (set automatically / by drag-and-drop), so only the stored doc requires it.
export const MentorShortSchema = MinimalMentorShortSchema.shape({
  id: yupUtils.stringRequired(),
  order: yupUtils.numberRequired,
  videoStreamPath: yupUtils.stringRequired(),
  thumbnailPath: yupUtils.stringOptionalNullable,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseMentorShort = async (object: any): Promise<MentorShort | ProjectErrorType> => {
  try {
    if (await isValidYupSchema(MentorShortSchema, object)) {
      return object as MentorShort;
    }
    return getProjectErrorForCode(ProjectErrors.invalidMentorShort);
  } catch (error) {
    console.log(`[MENTOR SHORTS] ID: ${object?.id}. Error:`, error);
    return getProjectErrorFromRawError(error as Error);
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseMentorShorts = async (items: any): Promise<MentorShort[]> => {
  if (!(items && Array.isArray(items))) {
    console.log('[MENTOR SHORTS] Error: No array found.');
    return [];
  }
  const data: MentorShort[] = [];
  for (const item of items) {
    const o = await parseMentorShort(item);
    if (o && !isProjectError(o)) {
      data.push(o as MentorShort);
    }
  }
  return data;
};
